import { Card, Grid, Modal, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';




const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};

function LogoutModal({ ...props }) {

  return (


    <Modal
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <MDBox >

          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
            <ErrorIcon style={{ color: "red" }} />
          </Typography>
          <MDTypography id="modal-modal-title" center={true} style={{ textAlign: "center" }} variant="h4" component="h2">
            You are about to logout.
          </MDTypography>
          <MDTypography id="modal-modal-title" center={true} style={{ textAlign: "center" }} variant="h6" component="h2">
            You will be log out, are you sure?
          </MDTypography>
          <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
            <MDButton color="secondary" style={{ width: "90px" }} onClick={props.handleCancel} >
              No
            </MDButton>
            &nbsp; &nbsp;
            <MDButton color="error" style={{ width: "90px" }} onClick={props.handleLogout} >
              Yes
            </MDButton>
          </Grid>

        </MDBox>
      </Card>

    </Modal>
  );
}

export default LogoutModal;
